// Recovered compiled webpack factory 61940. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "normalizeLocalePath", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }));
  let r = new WeakMap();
  function n(e, t) {
    let n;
    if (!t) return { pathname: e };
    let a = r.get(t);
    a || ((a = t.map((e) => e.toLowerCase())), r.set(t, a));
    let o = e.split("/", 2);
    if (!o[1]) return { pathname: e };
    let i = o[1].toLowerCase(),
      s = a.indexOf(i);
    return s < 0
      ? { pathname: e }
      : ((n = t[s]), { pathname: (e = e.slice(n.length + 1) || "/"), detectedLocale: n });
  }
}
